import React, { useState, useEffect } from "react";
import { X, Calendar } from "lucide-react";

export default function DeliveryDateModal({ isOpen, onClose, onSubmit, itemName }) {
  const [deliveryDate, setDeliveryDate] = useState("");

  useEffect(() => {
    if (isOpen) {
      // Default to today
      setDeliveryDate(new Date().toISOString().split("T")[0]);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(deliveryDate);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: "450px" }}>
        <div className="modal-header">
          <h3>Record Delivery Date</h3>
          <button className="modal-close-btn" onClick={onClose} type="button">
            <X size={18} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div style={{ padding: "1.5rem" }}>
            <div style={{ marginBottom: "1.25rem", color: "var(--text-secondary)", fontSize: "0.9rem", lineHeight: 1.4 }}>
              Please specify the delivery date for: <strong style={{ color: "var(--text-primary)" }}>{itemName}</strong>
            </div>

            <div className="form-group" style={{ marginBottom: "1.5rem" }}>
              <label className="form-label" style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <Calendar size={14} color="var(--primary)" />
                Delivery Date
              </label>
              <input
                type="date"
                className="form-input"
                value={deliveryDate}
                onChange={(e) => setDeliveryDate(e.target.value)}
                required
              />
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem" }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
              >
                Confirm Delivery
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
